'use server';

import { cookies } from 'next/headers';
import { FirebaseError } from 'firebase/app';
import { FirebaseAppError } from 'firebase-admin/app';
import { FIREBASE_AUTH_ERROR_MESSAGES, FIREBASE_AUTH_SESSION_CONFIG } from '@/constants/firebase';
import { ApiFetcherError } from '@/lib/api-fetcher';
import { firebaseAdminAuth } from '@/lib/firebase/firebase-admin';

export async function setFirebaseAdminAuthSession(options: { firebaseAuthIdToken: string }) {
  const { cookieName, cookieOptions } = FIREBASE_AUTH_SESSION_CONFIG;
  try {
    await firebaseAdminAuth.verifyIdToken(options.firebaseAuthIdToken);
    const nextCookies = await cookies();
    nextCookies.set(cookieName, options.firebaseAuthIdToken, cookieOptions);
  } catch (error: unknown) {
    console.warn('[Next.js server action] Set firebase admin auth session failed', error);
    if (error instanceof FirebaseAppError) {
      throw new FirebaseError(
        'auth/invalid-id-token',
        FIREBASE_AUTH_ERROR_MESSAGES['auth/invalid-id-token']
      );
    }
    throw new ApiFetcherError(
      500,
      '[Next.js server action] Set firebase admin auth session failed'
    );
  }
}

export async function clearFirebaseAdminAuthSession() {
  const { cookieName } = FIREBASE_AUTH_SESSION_CONFIG;
  try {
    const nextCookies = await cookies();
    nextCookies.delete(cookieName);
  } catch (error: unknown) {
    console.warn('[Next.js server action] Clear firebase admin auth session failed', error);
    throw new ApiFetcherError(
      500,
      `[Next.js server action] Clear firebase admin auth session failed`
    );
  }
}
